exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".item-image-container[_v-1a2858db]{width:100px;height:76px;display:inline-block;border:1px solid #bdbdbd;margin:-8px 9px 10px 0;padding:1px;box-shadow:0 0 3px rgba(0,0,0,.2)}.item-image-container img[_v-1a2858db]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.item-image-counter[_v-1a2858db]{display:block;position:absolute;background:hsla(0,0%,100%,.95);top:24px;right:12px;height:22px;padding:3px 5px 0;border-radius:11px;border:1px solid hsla(0,0%,75%,.95);box-shadow:0 0 1px rgba(0,0,0,.3);font-size:11px;color:#272727}.item-image-counter[_v-1a2858db]:hover{color:#000;background-color:#fff}.item-image-container[_v-1a2858db]:hover,.item-image-counter[_v-1a2858db]:hover{border-color:#72afd2;box-shadow:0 0 3px rgba(0,0,0,.4)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-1a2858db&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/templates/TemplateShapeView.vue
// module id = 147
// module chunks = 0